module.exports = __webpack_public_path__ + "static/works-digix-a796953af45f37abbdc36064ff960209.jpg";